var map = {
	"./10C.png": 49,
	"./10D.png": 50,
	"./10H.png": 51,
	"./10S.png": 52,
	"./1StackBlack.png": 26,
	"./1StackBlue.png": 27,
	"./1StackGreen.png": 28,
	"./1StackRed.png": 29,
	"./1StackWhite.png": 30,
	"./2C.png": 53,
	"./2D.png": 54,
	"./2H.png": 55,
	"./2S.png": 56,
	"./2StackBlack.png": 31,
	"./2StackBlue.png": 32,
	"./2StackGreen.png": 33,
	"./2StackRed.png": 34,
	"./2StackWhite.png": 35,
	"./3C.png": 57,
	"./3D.png": 58,
	"./3H.png": 59,
	"./3S.png": 60,
	"./3StackBlack.png": 16,
	"./3StackBlue.png": 19,
	"./3StackGreen.png": 17,
	"./3StackRed.png": 15,
	"./3StackWhite.png": 18,
	"./4C.png": 61,
	"./4D.png": 62,
	"./4H.png": 63,
	"./4S.png": 64,
	"./5C.png": 65,
	"./5D.png": 66,
	"./5H.png": 67,
	"./5S.png": 68,
	"./6C.png": 69,
	"./6D.png": 70,
	"./6H.png": 71,
	"./6S.png": 72,
	"./7C.png": 73,
	"./7D.png": 74,
	"./7H.png": 75,
	"./7S.png": 76,
	"./8C.png": 77,
	"./8D.png": 78,
	"./8H.png": 79,
	"./8S.png": 80,
	"./9C.png": 81,
	"./9D.png": 82,
	"./9H.png": 83,
	"./9S.png": 84,
	"./AC.png": 20,
	"./AD.png": 85,
	"./AH.png": 86,
	"./AS.png": 87,
	"./JC.png": 88,
	"./JD.png": 89,
	"./JH.png": 90,
	"./JS.png": 91,
	"./KC.png": 92,
	"./KD.png": 93,
	"./KH.png": 94,
	"./KS.png": 95,
	"./QC.png": 96,
	"./QD.png": 97,
	"./QH.png": 98,
	"./QS.png": 99,
	"./chips.png": 100,
	"./dealer.png": 22,
	"./red_back.png": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;